import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to load other pipes dynamically
 */
@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {
  /**
   * Transform
   *
   * @param value Any
   */
  transform(value: any): any {
      if(typeof(value) == 'string') return value.substring(0, value.length - 3);
  }
}